import { sendMessage } from '../services/websocket';
import { v4 as uuidv4 } from 'uuid';
import store from '../../store';
import getFormInfo from './getFormInfo';

const fetchData = () => {
  async function login(swHandle, empCode, password) {
    const txnLoginEmployee = {
      name: 'txn_user_login',
      folder: 'sessions',
      swhandle: swHandle,
      schema: swHandle + '_folders',
      foldertype: 'folders',
      label: {
        eng: 'User Login',
      },
      permissions: {
        env: '',
        row: '',
      },
      shared_permissions: {
        env: '',
        row: '',
      },
      schedule: {
        type: 'immediate',
      },
      params: {
        swhandle: swHandle,
        code: empCode,
        password: password,
      },
      client_props: {
        txn_op: 'X',
        cache_when: 'never',
      },
      display_order: 4,
      expected: [{}],
      template: 'body.tmpl',
      baseFolderPath: 'business.folders.sessions',
    };
    const retVal = await sendMessage(txnLoginEmployee);
    if (retVal.output.type === 'success') {
      const records = [];
      for (let i = 0; i < retVal.output.data.records.length; i++) {
        records.push(JSON.parse(retVal.output.data.records[i]));
      }
      retVal.output.data.records = records;
    }
    return retVal;
  }

  async function logout(swHandle) {
    const sessionId = store.getters['sessionIdGetter'];
    const txnLogoutEmployee = {
      name: 'txn_user_logout',
      folder: 'sessions',
      swhandle: swHandle,
      schema: swHandle + '_folders',
      foldertype: 'folders',
      label: {
        eng: 'User Logout',
      },
      permissions: {
        env: '',
        row: '',
      },
      shared_permissions: {
        env: '',
        row: '',
      },
      schedule: {
        type: 'immediate',
      },
      params: {},
      client_props: {
        txn_op: 'Y',
        cache_when: 'never',
      },
      display_order: 1,
      expected: [{}],
      session_key: sessionId,
      template: 'body.tmpl',
      baseFolderPath: 'business.folders.sessions',
    };
    return await sendMessage(txnLogoutEmployee);
  }

  async function signup(swHandle, empCode, password) {
    const currentDate = new Date();
    const joiningDate = currentDate
      .toISOString()
      .slice(0, 23)
      .replace('T', ' ');
    const txnBusinessSignup = {
      name: 'txn_businesses_sign_up',
      foldertype: 'folders',
      label: {
        eng: 'Business Sign Up'
      },
      permissions: {
        env: '',
        row: ''
      },
      shared_permissions: {
        env: '',
        row: ''
      },
      access_type: 'anonymous',
      schedule: {
        type: 'immediate'
      },
      tmpl: {
        platform: 'nodejs',
        name: 'business_sign_up.tmpl',
        server_target: 'shard',
        export: true
      },
      client_props: {
        txn_op: 'C',
        cache_when: 'never'
      },
      display_order: 3,
      folder: 'businesses',
      schema: 'aquafacility_folders',
      swhandle: 'aquafacility'
    }
    txnBusinessSignup.params = {
      swhandle: swHandle,
      code: empCode,
      password: password,
      joining_date: joiningDate,
      person_id: uuidv4()
    }
    return await sendMessage(txnBusinessSignup);
  }

  async function listData(folder, txnParams) {
    try {
      const sessionId = store.getters['sessionIdGetter'];
      let listTxn = {};
      if (folder?.name === 'attendance') {
        if (folder?.txnToCall) {
          listTxn = folder.txns[folder.txnToCall];
          delete folder['txnToCall']
        } else {
          listTxn = folder.txns['txn_attendance_list_with_summary'];
        }
      } else {
        for (let i = 0; i < folder.txn_list.length; i++) {
          if (folder.txn_list[i].slice(-4) === 'list') {
            listTxn = folder.txns[folder.txn_list[i]];
            break;
          }
        }
      }
      listTxn.record_identifier = "getValue(record, ['code'])";
      listTxn.session_key = sessionId;
      listTxn.params = txnParams;
      const retVal = await sendMessage(listTxn);
      if (retVal.output.type === 'success') {
        const records = [];
        for (let i = 0; i < retVal.output.data.records.length; i++) {
          records.push(JSON.parse(retVal.output.data.records[i]));
        }
        retVal.output.data.records = records;
      }
      return retVal;
    } catch (err) {
      console.log(err);
    }
  }
  async function getBusiness() {
    const txn_businesses_list = {
      'name': 'txn_businesses_list',
      'foldertype': 'folders',
      'refRows':true,
      'label': {
        'eng': 'List businesses'
      },
      'permissions': {
        'env': '',
        'row': ''
      },
      'shared_permissions': {
        'env': '',
        'row': ''
      },
      'tmpl': {
        'platform': 'plv8',
        'name': 'list.tmpl'
      },
      'client_props': {
        'txn_op': 'R',
        'cache_when': 'originator'
      },
      'display_order': -1,
      'folder': 'businesses',
      'schema': 'ddnews_folders',
      'swhandle': 'ddnews'
    }
    return await sendMessage(txn_businesses_list);
  }
  async function getEmployeeData(folder, txnParams) {
    try {
      const {getCurrentTxn} = getFormInfo()
      const listTxn = getCurrentTxn('list', folder, 'txn_employees_list')
      const sessionId = store.getters['sessionIdGetter'];
      listTxn.session_key = sessionId;
      listTxn.params = txnParams;
      console.log(listTxn)
      const retVal = await sendMessage(listTxn);
      if (retVal.output.type === 'success') {
        const records = [];
        for (let i = 0; i < retVal.output.data.records.length; i++) {
          records.push(JSON.parse(retVal.output.data.records[i]));
        }
        retVal.output.data.records = records;
      }
      return retVal;
    } catch (err) {
      console.log(err);
    }
  }
  async function sendMail(folder) {
    const { getCurrentTxn } = getFormInfo()
    const emailTxn = getCurrentTxn(null, folder, 'txn_email_send')
    console.log('in the composable', emailTxn)
  }

  return { login, logout, signup, listData, sendMail, getEmployeeData, getBusiness};
};

export default fetchData;
